export default function Hero() {
  return (
    <section id="inicio" className="relative min-h-screen flex items-center justify-center pt-20 px-6 lg:px-20">
      {/* Background Image Container */}
      <div className="absolute inset-0 mt-20 mx-6 lg:mx-20 rounded-[32px] overflow-hidden">
        <img
          src="https://static.readdy.ai/image/29b7010783f31bed38e001c5bfe381ee/64b95fed99388b692c9a481bf4d31bf7.jpeg"
          alt="Delicioso Kebab"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center max-w-4xl mx-auto py-32">
        <h1 className="text-5xl lg:text-7xl font-extrabold text-white leading-tight mb-6">
          El mejor kebab de <br />
          <span className="text-white">Pozuelo de Alarcón</span>
        </h1>
        
        <p className="text-xl lg:text-2xl text-white/90 font-medium mb-12">
          Kebabs, durums, pollo frito y mucho más
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-wrap gap-4 justify-center mb-8">
          <a
            href="tel:919123048"
            className="inline-flex items-center gap-3 bg-[#E63946] text-white px-12 py-5 rounded-full text-xl font-bold hover:bg-[#D62839] transition-all hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-fill text-2xl"></i>
            Llamar para pedir
          </a>
          
          <a
            href="https://wa.me/34643383317"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-[#25D366] text-white px-12 py-5 rounded-full text-xl font-bold hover:bg-[#20BA5A] transition-all hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-fill text-2xl"></i>
            WhatsApp
          </a>
        </div>

        {/* Phone Number */}
        <div className="mt-8 inline-block bg-[#A8DADC]/90 backdrop-blur-sm px-8 py-4 rounded-full animate-pulse">
          <p className="text-3xl lg:text-4xl font-extrabold text-white flex items-center gap-3">
            <i className="ri-phone-line"></i>
            919 123 048
          </p>
        </div>
      </div>
    </section>
  );
}